module.exports = __webpack_public_path__ + "img/shield-lock.33ac563d.svg";